// extracted by mini-css-extract-plugin
module.exports = {"title":"commonAuthStyles_title__2BAY0","subtitle":"commonAuthStyles_subtitle__1zun5","wrapper":"commonAuthStyles_wrapper__3fgYW"};